<template>
    <div id="app">
        <!-- <headersrem v-if="isRem" />
        <headers v-else /> -->
        <!-- <router-view style="margin-top: 1rem" /> -->
        <!-- <footersrem v-if="isRem" />
        <footers v-else /> -->
        <router-view />
    </div>
</template>

<script>
import headers from "./components/common/header";
import footers from "./components/common/footer";
import headersrem from "./components/common/headerrem";
import footersrem from "./components/common/footerrem";
export default {
    name: "App",
    data() {
        return {
            isRem: false,
        };
    },
    components: {
        headers,
        footers,
        headersrem,
        footersrem,
    },
    mounted() {
        this.isRem = document.body.clientWidth < 750;
    },
};
</script>
<style>
body {
    font-family: "微软雅黑";
    background: #fff;
    overflow-x: hidden;
}
.warp {
    max-width: 1594px;
    width: 100%;
    margin: 0 auto;
}
* {
    margin: 0;
    padding: 0;
}
ul li {
    list-style: none;
}
a {
    text-decoration: none;
}
img {
    display: block;
    width: 100%;
    image-rendering: -moz-crisp-edges; /* Firefox */
    image-rendering: -o-crisp-edges; /* Opera */
    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}
</style>



// WEBPACK FOOTER //
// src/App.vue